import initPageCarrefourCollection from './carrefourcollection'


const initEvents = () => {
    initPageCarrefourCollection();
}


export default initEvents;